(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  const sortMinistryProducts = (resultsList) => {
    const grid = resultsList.querySelector('.product-grid');
    if (!grid) return;

    const items = [...grid.children].filter((item) => item.hasAttribute('data-product-available'));
    let foundSoldOut = false;
    const needsSort = items.some((item) => {
      if (item.dataset.productAvailable === 'false') foundSoldOut = true;
      return foundSoldOut && item.dataset.productAvailable === 'true';
    });

    if (!needsSort) return;

    items
      .filter((item) => item.dataset.productAvailable === 'true')
      .forEach((item) => grid.appendChild(item));
    items
      .filter((item) => item.dataset.productAvailable === 'false')
      .forEach((item) => grid.appendChild(item));
  };

  const applyMinistrySizeFilter = (filter) => {
    const resultsList = filter.closest('results-list');
    if (!resultsList) return;

    const selectedSize = filter.querySelector('[data-ms-size-filter-select]')?.value || '';
    const items = resultsList.querySelectorAll('[data-product-size]');

    items.forEach((item) => {
      item.classList.toggle('ms-size-filter-hidden', Boolean(selectedSize) && item.dataset.productSize !== selectedSize);
    });
  };

  const initializeMinistrySizeFilters = (root = document) => {
    root.querySelectorAll('[data-ms-size-filter]').forEach((filter) => {
      if (filter.dataset.initialized === 'true') return;
      filter.dataset.initialized = 'true';

      const select = filter.querySelector('[data-ms-size-filter-select]');
      const resultsList = filter.closest('results-list');
      if (!select || !resultsList) return;

      select.value = '';

      const url = new URL(window.location.href);
      if (url.searchParams.has('size')) {
        url.searchParams.delete('size');
        window.history.replaceState({}, '', url);
      }

      select.addEventListener('change', () => applyMinistrySizeFilter(filter));

      new MutationObserver(() => {
        sortMinistryProducts(resultsList);
        applyMinistrySizeFilter(filter);
      }).observe(resultsList, {
        childList: true,
        subtree: true,
      });

      sortMinistryProducts(resultsList);
      applyMinistrySizeFilter(filter);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMinistrySizeFilters(), { once: true });
  } else {
    initializeMinistrySizeFilters();
  }

  document.addEventListener('shopify:section:load', (event) => initializeMinistrySizeFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-homepage"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
